<template>
    <div class="w-full">
        <!-- Mismo contenedor y ancho que create-procedure/question-sfc-procedure -->
        <div class="single-window-container mx-auto px-5 sm:px-6 lg:px-8">
            <section class="w-full" aria-labelledby="ventanilla-options-title">
                <h2 id="ventanilla-options-title"
                    class="text-center text-lg md:text-xl font-semibold text-blue-dark mt-0 mb-8">
                    Seleccione una opción:
                </h2>
                <ul aria-labelledby="ventanilla-options-title" class="flex flex-col gap-8 w-full m-0 p-0 list-none">
                    <li v-for="option in options" :key="option.id" class="flex w-full">
                        <HomeOptionCard clickable :icon="option.icon" :label="option.label" :items="option.items"
                            :selected="selected === option.id" @click.native="onSelect(option)" />
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>

<script>
import newRequestIcon from "@/assets/icons/single_window/new-request.svg";
import consultStatusIcon from "@/assets/icons/single_window/consult-status.svg";
import addInfoIcon from "@/assets/icons/single_window/add-info.svg";
import HomeOptionCard from "@/feature/single_window/home/presentation/partials/HomeOptionCard.vue";

export default {
    name: "HomeOptions",
    components: {
        HomeOptionCard,
    },
    data() {
        return {
            // Opción actualmente seleccionada (resalta la tarjeta con borde azul).
            selected: "",
        };
    },
    computed: {
        options() {
            // Enlaces internos a las rutas del módulo single-window
            // (ver src/router/modules/single-window.router.js).
            return [
                {
                    id: "new",
                    label: "Crear nueva solicitud de trámite",
                    icon: newRequestIcon,
                    to: "/single-window/create-procedure",
                    // Literales exactos del contenido aprobado (incluye errores tipográficos intencionales).
                    items: [
                        "Inconformidades y conciliaciones extrajudiciales con entidaddes vigiladas por la Superfinanciera.",
                        "Demandas contra entidades vigildas por la Superfinanciera.",
                        "Peticiones, quejas, reclamos, denuncias, solicitudes, felicitaciones y otros tramites relacionadas con la atención y los servicios de la SFC.",
                    ],
                },
                {
                    id: "consult",
                    label: "Consultar estado del trámite",
                    icon: consultStatusIcon,
                    to: "/single-window/check-status-procedure",
                    items: ["Estado actual de su trámire, avance y gestión de su solicitud."],
                },
                {
                    id: "add",
                    label: "Adicionar información a solicitud existente",
                    icon: addInfoIcon,
                    to: "/single-window/add-info-request",
                    items: ["Registro de documentos o información adicional a un número de radicado existente."],
                },
            ];
        },
    },
    methods: {
        onSelect(option) {
            // Marca la tarjeta seleccionada (borde azul) y navega a su ruta.
            // Pequeño retardo para que el estado seleccionado sea perceptible
            // antes de cambiar de vista dentro de la SPA.
            this.selected = option.id;
            if (option.to) {
                setTimeout(() => {
                    this.$router.push(option.to).catch(() => {});
                }, 150);
            }
        },
    },
};
</script>

<style scoped>
/*
 * Mismo ancho máximo del contenedor que en create-procedure/question-sfc-procedure
 * para igualar el espaciado horizontal entre vistas del módulo single-window.
 */
.single-window-container {
    max-width: 960px;
}

/*
 * Altura mínima uniforme para que las tres tarjetas se vean del mismo tamaño.
 * El valor se ajusta al alto de la tarjeta con más contenido (la primera, con
 * tres viñetas) para que las demás igualen esa altura sin espacio sobrante.
 * `::v-deep` alcanza la clase raíz del componente hijo HomeOptionCard.
 */
.single-window-container ::v-deep .ventanilla-card {
    min-height: 150px;
}
</style>
